import AdminInstance from 'modules/admin/repository';

export const getScriptLogs = (page, size, search, filters) => {
  return AdminInstance.getScriptLogs({
    page, size, search, filters,
  });
};
